// Common options for exporting buttons
const commonButtonOptions = {
  symbolStroke: 'var(--dark-light-dynamic-text)', // Icon color
  symbolFill: 'var(--dark-white-dynamic-bg)', // Background for the symbol
  theme: {
    fill: 'var(--dark-white-dynamic-bg)', // Button background
    style: {
      color: 'var(--dark-light-dynamic-text)', // Text color
    },
    states: {
      hover: {
        fill: 'var(--dynamic-hover-bg)', // Hover background color
        style: {
          color: 'var(--dark-white-dynamic-text)', // Hover text color
        },
      },
    },
  },
};

// Global options for Highcharts across the entire app
export const globalOptions: Highcharts.Options = {
  credits: {
    enabled: false,
  },
  lang: {
    decimalPoint: '.',
    thousandsSep: ',',
    contextButtonTitle: 'Download Image/Data',
    zoomButtonTitle: 'View in Fullscreen',
    settingsButtonTitle: 'Chart Settings',
  } as Highcharts.LangOptions, // Override the type since we're setting custom keys
  chart: {
    backgroundColor: 'var(--dark-white-dynamic-bg)',
  },
  caption: {
    style: {
      color: 'var(--black-white-dynamic-text)',
    },
  },
  title: {
    style: {
      color: 'var(--dark-white-dynamic-text)',
    },
  },
  xAxis: {
    lineColor: 'var(--dark-white-dynamic-text)',
    labels: {
      style: {
        color: 'var(--dark-white-dynamic-text)',
      },
    },
  },
  yAxis: {
    gridLineColor: 'var(--dynamic-chart-grid-lines)',
    labels: {
      style: {
        color: 'var(--dark-white-dynamic-text)',
      },
    },
    title: {
      style: {
        color: 'var(--dark-white-dynamic-text)',
      },
    },
  },
  colorAxis: {
    labels: {
      style: {
        color: 'var(--dark-white-dynamic-text)',
      },
    },
  },
  legend: {
    itemStyle: {
      color: 'var(--dark-white-dynamic-text)',
    },
    itemHoverStyle: {
      color: 'var(--dynamic-chart-legend-hover)',
    },
  },
  exporting: {
    // action buttons (export, zoom, settings)
    buttons: {
      contextButton: {
        ...commonButtonOptions,
        titleKey: 'contextButtonTitle',
      },
      zoomButton: {
        ...commonButtonOptions,
        titleKey: 'zoomButtonTitle',
      },
      settingsButton: { ...commonButtonOptions, titleKey: 'settingsButtonTitle' },
    },
  },
  navigation: {
    breadcrumbs: {
      buttonTheme: {
        style: {
          color: 'var(--dynamic-link-color)',
        },
      },
      separator: {
        style: {
          color: 'var(--dark-white-dynamic-text)',
        },
      },
      position: {
        y: -35,
      },
    },
  },
};
